<template>
  <Modal :value="value" @hide="hide()" title="Global license">
    <template v-if="serverLicense" slot="body" class="content">
      <h2 class="title is-size-6">Update license</h2>
      <p>
        You can update the global license manually if you have changed your
        subscriptions recently in the
        <a target="_blank" href="https://licensing.deployify.io"
          >license portal</a
        >.
      </p>

      <div class="tags has-addons is-inline ">
        <span class="tag  is-light">Free</span>
        <span
          class="tag "
          :class="serverLicense.free <= 0 ? 'is-danger' : 'is-success'"
          >{{ serverLicense.free }}</span
        >
      </div>

      <div class="tags  has-addons margin-left-10 is-inline">
        <span class="tag  is-light">Total</span>
        <span class="tag  is-info">{{ serverLicense.total }}</span>
      </div>
    </template>
    <template slot="footer" class="content">
      <div v-if="!isLoading">
        <div @click="reloadGlobalLicense()" class="button is-primary">
          Update
        </div>

        <div class="button" @click="hide()">Close</div>
      </div>
      <div v-show="isLoading" class="spinner-wrapper center">
        <span class="spinner is-centered"></span>
      </div>
    </template>
  </Modal>
</template>
<script>
import { postApi } from "@/utils/http";

export default {
  props: {
    value: Boolean
  },
  components: {
    Modal: () => import("@/components/main/Modal.vue")
  },
  data() {
    return {
      isLoading: false,
      serverLicense: null
    };
  },
  async created() {
    await this.reloadGlobalLicense(true);
  },
  methods: {
    async getGlobalLicense() {
      try {
        this.isLoading = true;
        const res = await postApi("get/serverLicense", {});
        this.serverLicense = res;
        this.isLoading = false;
      } catch (e) {
        if (e.response.status === 500)
          this.$helpers.notify("Error", "Internal server error.", "danger");
        else {
          this.$helpers.notify("Error", "Unknown error.", "danger");
        }
      }
    },

    async reloadGlobalLicense(skipMessage) {
      try {
        this.isLoading = true;
        const res = await postApi("reload/serverLicense", {});
        this.serverLicense = res;
        this.isLoading = false;

        await this.getGlobalLicense();

        if (!skipMessage) {
          this.$helpers.notify(
            "Success",
            "The global license has been updated."
          );
        }
      } catch (e) {
        if (e.response.status === 500)
          this.$helpers.notify("Error", "Internal server error.", "danger");
        else {
          this.$helpers.notify("Error", "Unknown error.", "danger");
        }
      }
    },

    hide() {
      if (!this.isLoading) {
        this.$emit("hide", false);
        this.$emit("input", false);
      }
    }
  }
};
</script>
